import React from 'react'

import DndManager from "../../../core/gd-modules/dnd/managers/dnd-manager"
import ReorderListNoDiv, {ReorderListType} from "./reorder-list-no-div"

type Props = {
    items                   : {
        item        : any
        component   : any
    }[]

    previewLayerClasses?    : string
    dndManager?             : DndManager

    type?                   : ReorderListType
    disabled?               : boolean

    keyFunction             : func
    onReorder               : func
}

export default class ReorderList extends React.Component<Props> {

    public dndManager   : DndManager

    static defaultProps = {
        type: ReorderListType.VERTICAL
    }

    constructor(props:any) {
        super(props);

        this.dndManager = props.dndManager ? props.dndManager : new DndManager()
    }

    render() {
        return <ReorderListNoDiv {...this.props} dndManager={this.dndManager}/>
    }
}
